import type { PaymentErrorResult, PaymentFetchResponse } from '../../Checkout.types';

export function handleSubscriptionPaymentError(
  response: PaymentFetchResponse
): PaymentErrorResult | void {
  const code = response.data?.error;

  if (code === 'Bad Request: Has DFR') {
    const properties = response.data?.properties ?? [];
    return {
      previousStep: true,
      alerts: [
        {
          title: 'Du har redan Plus på en eller flera fastigheter du försökte köpa',
          subtitle:
            'Nedan fastighet(er) har redan en Plus prenumeration och kommer inte inkluderas i köpet',
          designation: properties.join(', '),
          helperInfo: 'Vänligen kontakta oss för hjälp med din beställning.'
        }
      ]
    };
  }

  if (code === 'Bad Request: Active subscription invoice') {
    return {
      previousStep: true,
      alerts: [
        {
          title: 'Det finns redan en aktiv faktura kopplad till ditt konto.',
          subtitle: 'Du kan därför inte gå vidare till betalning.',
          helperInfo: 'Vänligen slutför eller hantera den befintliga fakturan först'
        }
      ]
    };
  }

  return { genericError: true };
}
